export * from './src/badges-v4-badge-badges-v-2.meta.js';
